import { render, staticRenderFns } from "./NisConnectionsScore.vue?vue&type=template&id=64319618&scoped=true"
import script from "./NisConnectionsScore.vue?vue&type=script&lang=js"
export * from "./NisConnectionsScore.vue?vue&type=script&lang=js"
import style0 from "./NisConnectionsScore.vue?vue&type=style&index=0&id=64319618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64319618",
  null
  
)

export default component.exports